/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, createContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { Select, CircularProgress, FormControl, MenuItem, Button, Grid, Backdrop, FormControlLabel, Checkbox, FormGroup, RadioGroup, Radio, Tooltip } from '@mui/material';
// import FmdBadIcon from '@mui/icons-material/FmdBad';
import ErrorIcon from '@mui/icons-material/Error';
import { isEmpty } from 'lodash';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import './cip.scss';
import Notification from '../../shared/notification-modal';
import SystemUnits from '../system-units';
import { convertUnitValues_volume } from '../../shared/conversion-helper/unitConversion';
import { closeIconBlack, systemUnitsIconColor } from '../../shared/assets/images';
import { decrypt_data } from '../../shared/utils';
import { CIPCalculatorApi, dbTransaction, download_spec_file } from '../../shared/api/url-helper';
import ReportCipPopup from './Report-CIP';
import { defaultModalOptions } from '../../shared/constantVariable';
import { getRegion } from '../../shared/Products';
import { clearLogs } from '../../logger';
import { getDbTransactionData, setDbTransactionData } from '../userData';

export const ExecuteContext = createContext();
const unit_set_dict = { 'Volume Flow': 'gpm', 'Pressure': 'atm', 'Temperature': '°C', 'Liquid Volume': 'gal', 'Flux': 'gfd', 'Power': 'kW' };
const defaultValue = { novessal: 1, elevessal: 1, ele: 0, volpip: 0, voltank: 0, pipingflag: false };
const cleaningFoulantOption = [
  { key: 'Carbonate Scaling', val: 'Carbonate Scaling' },
  { key: 'Colloidal Fouling', val: 'Colloidal Fouling' },
  { key: 'Metal Oxide Scaling', val: 'Metal Oxide Scaling' },
  { key: 'Microbiological Fouling', val: 'Microbiological Fouling' },
  { key: 'Organic and Chemical Fouling', val: 'Organic and Chemical Fouling' },
  { key: 'Silical and silicate Scaling', val: 'Silical and silicate Scaling' },
  { key: 'Sulphate Scaling', val: 'Sulphate Scaling' },
  { key: 'General guidelines', val: 'General guidelines' },
  { key: 'Recomended CIP mixed foulants', val: 'Recomended CIP mixed foulants' }
];
const foulantOption = [
  { 'key': 'carbonates', value: 'Carbonates' },
  { 'key': 'sulphates', value: 'Sulphates' },
  { 'key': 'metal_oxide', value: 'Metal Oxide(Fe, Mn, Al)' },
  { 'key': 'silica', value: 'Silica and Silicates' },
  { 'key': 'colloids', value: 'Colloids' },
  { 'key': 'oils_grease', value: 'Oils and Greases' },
  { 'key': 'cationic_poly', value: 'Cationic Polymers' },
  { 'key': 'bacterial', value: 'Bacterial Activity' },
  { 'key': 'organics', value: 'Organics' },
];
// const names = [
//   'Oliver Hansen',
//   'Van Henry',
//   'April Tucker',
//   'Ralph Hubbard',
//   'Omar Alexander',
//   'Carlos Abbott',
//   'Miriam Wagner',
//   'Bradley Wilkerson',
//   'Virginia Andrews',
//   'Kelly Snyder',
// ];
// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

function CIP_Calculator_Form() {
  // const navigate = useNavigate();
  const { t } = useTranslation();
  const translateObject = t;
  const [fetchLoading, setFetchLoading] = useState(false);
  const [StagesValue, setStagesValue] = useState(1);
  const [TrainsValue, setTrainsValue] = useState(1);
  const [visibleUnits, setVisibleUnits] = useState(false);
  const [stageData, setStageData] = useState([JSON.parse(JSON.stringify(defaultValue))]);
  const [, setIntialStageData] = useState([JSON.parse(JSON.stringify(defaultValue))]);
  const executeEDIInfoData = useMemo(() => ({ data: {}, reportData: {} }), []);
  const [cipSelect, setCipSelect] = useState('1');
  const [cipNotification, setCipNotification] = useState(false);
  const [isVolumeDisabled, setIsVolumeDisabled] = useState(false);
  const [membrane_value, setMembrane_value] = useState('polyamide');
  const [foulantselect, setFoulantselect] = useState('');
  const [cleanerSelect, setCleanerSelect] = useState('0');
  const [strengthSelect, setStrengthSelect] = useState(0);
  const [main_checked, setMain_checked] = useState(true);
  const [nsf_checked, setNsf_checked] = useState(false);
  const [strategiesSelect, setStrategiesSelect] = useState('');
  const [showReportPopup, setShowReportPopup] = useState(false);
  const [cipReportData, setCipReportData] = useState('');
  const [reportDataObj, setReportDataObj] = useState('');
  const [PreVolumeValue, setPreVolumeValue] = React.useState('');
  const [units, setUnits] = useState(unit_set_dict);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [dbTransactionDetails, setDbTransactionDetails] = useState({});
  // if (sessionStorage.getItem('expTime') == null) {
  //   window.location.href = '/sign-in';
  // }

  const SessionExpTime = sessionStorage.getItem('expTime');
  let currTime = new Date().getTime().toString();
  currTime = currTime.substring(0, 10); // 1653312386

  if (parseInt(currTime) >= parseInt(SessionExpTime)) {
    // removeItemFromLocalStorage();
    if (localStorage.getItem('db_version')) {
      localStorage.removeItem('db_version');
    }
    clearLogs();
    window.location.href = '/sign-in';
  };
  const handleCloseOption = () => {
    setVisibleUnits(false);
  };
  const closeModelOption = () => {
    setModalOption(defaultModalOptions);
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => closeModelOption,
      type,
    });
  };

  const handleChange = (event) => {
    setCipSelect(event.target.value);
    setCipNotification(false);
    setIsVolumeDisabled(false);
    if (Number(event.target.value) === 0) {
      setCipNotification(true);
      setIsVolumeDisabled(true);
    }
  };
  const handleElementChange = (event, ind) => {
    const data = [...stageData];
    data[ind].ele = event.target.value;
    setStageData(data);
  };
  const changeCIPpiping = (event, ind) => {
    const data = [...stageData];
    data[ind].volpip = Number(event.target.value);
    setIntialStageData(data);
    setStageData(data);
  };
  const hoverPiping = (flag, ind) => {
    const data = [...stageData];
    data[ind].pipingflag = flag;
    setStageData(data);
  };
  const changeCIPtank = (event, ind) => {
    const data = [...stageData];
    data[ind].voltank = Number(event.target.value);
    setIntialStageData(data);
    setStageData(data);
  };

  const handleCleanerChange = (event) => {
    setCleanerSelect(event.target.value);
  };
  const handleStrengthChange = (event) => {
    setStrengthSelect(event.target.value);
  };
  const handleStrategiesChange = (event) => {
    setStrategiesSelect(event.target.value);
  };
  const selectRegistrationValue = (event, str) => {
    setFoulantselect('');
    setNsf_checked(false);
    setMain_checked(false);
    if (str === 'nsf') {
      setNsf_checked(event.target.checked);
    } else if (str === 'maintenance') {
      setMain_checked(event.target.checked);
    } else if (str === 'foulant') {
      setFoulantselect(event.target.value);
    }
  };
  const changeStageInputVal = (event, str) => {
    if (str === 'inc') {
      if (StagesValue < 3) {
        setStagesValue(StagesValue + 1);
        stageData.push(JSON.parse(JSON.stringify(defaultValue)));
        setStageData(stageData);
      }
    } else if (str === 'dec') {
      if (StagesValue > 1) {
        stageData.pop();
        setStagesValue(StagesValue - 1);
      }
    }
  };
  const changeTrainsInputVal = (event, str) => {
    if (str === 'inc') {
      if (TrainsValue < 8) {
        setTrainsValue(TrainsValue + 1);
      }
    } else if (str === 'dec') {
      if (TrainsValue > 1) {
        setTrainsValue(TrainsValue - 1);
      }
    }
  };
  const changeNumberVessels = (event, ind, str) => {
    const data = [...stageData];
    if (str === 'inc') {
      if (data[ind].novessal < 999) {
        data[ind].novessal += 1;
      }
    } else if (str === 'dec') {
      if (data[ind].novessal > 1) {
        data[ind].novessal -= 1;
      }
    }
    setStageData(data);
  };
  const changeElementVessels = (event, ind, str) => {
    const data = [...stageData];
    if (str === 'inc') {
      if (data[ind].elevessal < 8) {
        data[ind].elevessal += 1;
      }
    } else if (str === 'dec') {
      if (data[ind].elevessal > 1) {
        data[ind].elevessal -= 1;
      }
    }
    setStageData(data);
  };
  const getReportCipCalulator = async () => {
    const foulantObj = {};
    foulantOption.map((ele) => {
      foulantObj[ele.key] = 0;
      if (foulantselect.indexOf(ele.value) >= 0) {
        foulantObj[ele.key] = 1;
      }
    });
    const region = getRegion() || 'SEA';
    const obj = {
      cip_pip_tank: [],
      cip_pip_vol: [],
      cleaner_strength: Number(strengthSelect),
      // cleaner_type: (document.querySelector('.cleaner_type > div').className.indexOf('Mui-disabled') > 0) ? '' : cleanerSelect,
      cleaner_type: Number(cleanerSelect),
      foulant_type: foulantObj,
      maintenance: main_checked,
      name: 'CIP',
      nsf: nsf_checked,
      region: region.region,
      'Unit Type': 'CIP',
      ro_param: {
        elem_type: [],
        num_elements: [],
        num_vessels: [],
        num_stages: StagesValue,
        polymide_material: (membrane_value === 'polyamide') ? true : false,
        trainsValue: TrainsValue
      },
      strm_type_series: Number(cipSelect),
      metric: units['Liquid Volume'] === 'gal' ? false : true,
      unitset_dict: units
    };
    stageData.map((ele) => {
      obj.cip_pip_tank.push(parseFloat(convertUnitValues_volume(ele.voltank, units['Liquid Volume'], 'l').toFixed(1)));
      obj.cip_pip_vol.push(parseFloat(convertUnitValues_volume(ele.volpip, units['Liquid Volume'], 'l').toFixed(1)));
      obj.ro_param.num_vessels.push(Number(ele.novessal));
      obj.ro_param.num_elements.push(Number(ele.elevessal));
      obj.ro_param.elem_type.push(Number(ele.ele));
    });
    setFetchLoading(true);
    // const cipher_new = encrypt_data(obj);
    CIPCalculatorApi(obj).then(async (response) => {
      // response.data = await decompressedData_with_decrypt(response.data);
      if (response.data && Object.keys(response.data.results).length > 0) {
        obj.trainsValue = TrainsValue;
        setCipReportData(response.data);
        setReportDataObj(obj);
        setFetchLoading(false);
        setShowReportPopup(true);
      } else {
        openModelPopUp('Something is wrong.', 'Error', 'error');
        setFetchLoading(false);
      }
    });
  };

  const CIPFactSheetObj = {
    'Carbonate Scaling': 'Carbonate_Scaling_Argo.pdf',
    'Colloidal Fouling': 'Colloidal_Fouling_Argo.pdf',
    'Metal Oxide Scaling': 'Metal_Oxide_Scaling_Argo.pdf',
    'Microbiological Fouling': 'Microbiological_Fouling_Argo.pdf',
    'Organic and Chemical Fouling': 'Organic_and_Chemical_Fouling_Argo.pdf',
    'Silical and silicate Scaling': 'Silica_and_Silicate_Scaling_Argo.pdf',
    'Sulphate Scaling': 'Sulphate_Scaling_Argo.pdf',
    'General guidelines': 'TB1194EN_Argo.pdf',
    'Recomended CIP mixed foulants': 'Recomended CIP mixed foulants_Argo.pdf'
  };

  // const handleCIPdd_old = async (val) => {
  //   setFetchLoading(true);
  //   // 1. Configure AWS SDK
  //   AWS.config.update({
  //     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  //     secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  //     region: 'us-east-1',
  //   });

  //   const s3 = new AWS.S3();
  //   // 2. S3 Object Parameters
  //   const params = {
  //     Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
  //     Key: `winflows_file_management/CIP_factsheets/${CIPFactSheetObj[val]}` // 'path/to/your/pdf-file.pdf',
  //   };

  //   try {
  //     // 3. Get the PDF object from  S3
  //     const data = await s3.getObject(params).promise();

  //     // 4. Create a Blob from the S3 object data
  //     const blob = new Blob([data.Body], { type: 'application/pdf' });
  //     setFetchLoading(false);

  //     // 5. Create a download link and trigger the download
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', `${CIPFactSheetObj[val]}.pdf`); // Set download filename
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (error) {
  //     openModelPopUp('Somthing is wrong.', 'Error', 'error');
  //     setFetchLoading(false);
  //   }
  // };

  const handleCIPdd = async (val) => {
    setFetchLoading(true);
    download_spec_file(CIPFactSheetObj[val])
      .then((response) => {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        setFetchLoading(false);

        // Create a download link and trigger the download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${CIPFactSheetObj[val]}.pdf`); // Set download filename
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => {
        openModelPopUp('Somthing is wrong.', 'Error', 'error');
        console.error(err);
        setFetchLoading(false);
      });
  };
  useEffect(() => {
    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      setUnits(JSON.parse(localStorage.getItem('unit_set_dict')));
    }
    setPreVolumeValue(units['Liquid Volume']);
  }, [visibleUnits]);
  useEffect(() => {
    const data = [...stageData].map((d) => {
      if (d.volpip || d.voltank) {
        d.volpip = parseFloat(convertUnitValues_volume(d.volpip, PreVolumeValue, units['Liquid Volume']));
        d.voltank = parseFloat(convertUnitValues_volume(d.voltank, PreVolumeValue, units['Liquid Volume']));
      }
      return d;
    });
    // setIntialStageData(data);
    const formatData = data.map((d) => {
      if (d.volpip || d.voltank) {
        d.volpip = parseFloat(d.volpip.toFixed(1));
        d.voltank = parseFloat(d.voltank.toFixed(1));
      }
      return d;
    });
    setStageData(formatData);
  }, [units]);
  useEffect(() => {
    const decData = getDbTransactionData();
    if (decData) {
      setDbTransactionDetails(decData);
    } else {
      Promise.all([dbTransaction()]).then((res) => {
        const decData = decrypt_data(res[0].data);
        res[0].data = decData;
        setDbTransactionDetails(decData);
        setDbTransactionData(decData);
      });
    }
  }, []);
  // const [personName, setPersonName] = React.useState([]);
  const closeQuickViewPopup = () => {
    setShowReportPopup(false);
  };
  const membraneMaterial = (event) => {
    setMembrane_value(event.target.value);
    if (event.target.value === 'cellulose acetate') {
      setCleanerSelect(0);
    }
  };

  return (
    <Grid container className='CIP_Container'>
      <Grid item xs={12} className='Main_Heading L_heading'><span>{translateObject('CIP Calculator')}</span></Grid>
      <Grid item xs={12}>
        {fetchLoading && <Backdrop
          sx={{ color: '#fff', zIndex: 99999 }}
          style={{
            background: '#d9dbde5c',
          }}
          open={fetchLoading}>
          <CircularProgress style={{ color: '#4b93f4' }} size={40} disableShrink />
        </Backdrop>}
        <Notification options={modalOption} handleClose={() => closeModelOption()} />
      </Grid>
      <Grid container xs={12} className='PreConfig_container'>
        <Grid xs={12} md={12} style={{ height: '100%', overflow: 'auto' }}>
          <Grid xs={12} md={12} className='system_design_cip mob-view'>
            <span className='cip_system_design'>{translateObject('System Design')}</span>
            <Grid xs={12} className='flex'>
              <Grid xs={6} className='flex-w mob-view-satge'>
                <Grid xs={5} className='stage_clip'>
                  <span className='no_stage'>{translateObject('No of Stages')}</span>
                  <div className='flex-w'>
                    <RemoveCircleIcon onClick={(e) => { changeStageInputVal(e, 'dec'); }} className='inc-dec' />
                    <input disabled min="1" max="3" type='number' id='safefactvol' value={StagesValue} onFocus={e => e.target.select()} onInput={(e) => { setStagesValue(e.target.value); }}
                      className=' Defautl_Large_input' placeholder={translateObject('0')} />
                    <AddCircleIcon onClick={(e) => { changeStageInputVal(e, 'inc'); }} className='inc-dec' />
                  </div>
                </Grid>
                <Grid xs={7} className='stage_clip'>
                  <span className='no_stage'>{translateObject('No of RO Trains')}</span>
                  <Grid className='flex-w'>
                    <RemoveCircleIcon onClick={(e) => { changeTrainsInputVal(e, 'dec'); }} className='inc-dec' />
                    <input disabled type='number' id='safefactvol' value={TrainsValue} onFocus={e => e.target.select()} onInput={(e) => { setTrainsValue(e.target.value); }}
                      className=' Defautl_Large_input' placeholder={translateObject('0')} />
                    <AddCircleIcon onClick={(e) => { changeTrainsInputVal(e, 'inc'); }} className='inc-dec' />
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={6} className='flex-w mob-view-report'>
                <Grid xs={6} className='stage_clip'>
                  <FormControl className='cip_form_control cleaned-series' sx={{ m: 1, minWidth: 120 }}>
                    <Select id='srPrll' value={cipSelect} onChange={handleChange}>
                      <MenuItem id='op1sr' value='0'>{translateObject('Stages Cleaned in Series')}</MenuItem>
                      <MenuItem id='op2prl' value='1'>{translateObject('Stages Cleaned in Parallel')}</MenuItem>
                    </Select>
                  </FormControl>
                  <Button aria-label="units" className='icon_Button' onClick={() => { setVisibleUnits(true); }}>
                    <img src={systemUnitsIconColor} className="img-top" alt='units_color' />
                  </Button>
                </Grid>
                <Grid xs={6} className='stage_clip get-report'>
                  <Button disabled={!nsf_checked && !main_checked && !foulantselect} id='get_report' onClick={() => { getReportCipCalulator(); }} className={(!nsf_checked && !main_checked && !foulantselect) ? 'disabled' : 'backgroud-primary-default'} variant="contained">{translateObject('Get Report')}</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} className='stage_parent'>
            <Grid item xs={8} md={8} className='stage_left_child'>
              {stageData.map((ele, ind) => {
                return (
                  <div key={ind} className='system_design_cip cip_stage'>
                    <div className='mob-stage-num'>
                      <span className='cip_system_design'>{translateObject('Stage')} {ind + 1}</span>
                    </div>
                    <div className='mob-stage-index'>
                      <Grid xs={6} className='stage_clip cip_vessels'>
                        <span className='no_stage' title={translateObject('No of Vessels')}>{translateObject('No of Vessels')}</span>
                        <div className='vessels'>
                          <RemoveCircleIcon onClick={(e) => { changeNumberVessels(e, ind, 'dec'); }} style={{ width: 14, color: '#002d62' }} className='inc-dec' />
                          <input disabled type='number' id='safefactvol' value={ele.novessal} onFocus={e => e.target.select()} className=' Defautl_Large_input' placeholder={translateObject('0')} />
                          <AddCircleIcon onClick={(e) => { changeNumberVessels(e, ind, 'inc'); }} style={{ width: 14, color: '#002d62' }} className='inc-dec' />
                        </div>
                      </Grid>
                      <Grid xs={6} className='stage_clip cip_vessels'>
                        <span className='no_stage' title={translateObject('Element/Vessel')}>{translateObject('Element/Vessel')}</span>
                        <div className='vessels'>
                          <RemoveCircleIcon onClick={(e) => { changeElementVessels(e, ind, 'dec'); }} style={{ width: 14, color: '#002d62' }} className='inc-dec' />
                          <input disabled type='number' id='safefactvol' value={ele.elevessal} onFocus={e => e.target.select()} onInput={(e) => { setStagesValue(e.target.value); }}
                            className=' Defautl_Large_input' placeholder={translateObject('0')} />
                          <AddCircleIcon onClick={(e) => { changeElementVessels(e, ind, 'inc'); }} style={{ width: 14, color: '#002d62' }} className='inc-dec' />
                        </div>
                      </Grid>
                      <Grid xs={6} className='stage_clip cip_vessels'>
                        <span className='no_stage' title={translateObject('Element')}>{translateObject('Element')}</span>
                        <div className='vessels'>
                          <FormControl className='cip_form_control' sx={{ m: 1, minWidth: 120 }}>
                            <Select value={ele.ele} onChange={(e) => { handleElementChange(e, ind); }}>
                              <MenuItem value='0'>8&quot; x 40&quot;</MenuItem>
                              <MenuItem value='1'>4&quot; x 40&quot;</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid xs={6} className='stage_clip cip_vessels' style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span className='no_stage' style={{ position: 'relative' }} title={translateObject('Vol in CIP piping')}>
                            {translateObject('Vol in CIP piping')}
                          </span>
                          <ErrorIcon onMouseEnter={() => { hoverPiping(true, ind); }} onMouseLeave={() => { hoverPiping(false, ind); }} style={{ color: '#2d2d2d', fontSize: 14 }} />
                        </div>
                        <div className='vessels'>
                          <input
                            type='number'
                            id='piping_0'
                            disabled={ind === 0 ? false : isVolumeDisabled}
                            value={ele.volpip}
                            onFocus={e => e.target.select()}
                            onInput={(e) => { changeCIPpiping(e, ind); }}
                            className='cancel-handle Defautl_Large_input'
                            placeholder={translateObject('0')}
                            pattern="[0-9]"
                          />
                          <span className='cip_system_design S_Bold'>{units['Liquid Volume'] || unit_set_dict['Liquid Volume']}</span>
                        </div>
                        {ele.pipingflag &&
                          <div className='noti-wrapper' onMouseEnter={() => { hoverPiping(true, ind); }} onMouseLeave={() => { hoverPiping(false, ind); }}>
                            <ul>
                              <li style={{ padding: '12px 0', borderRight: '1px solid white', lineHeight: 1 }}><span>Pipe diameter (in)</span></li>
                              <li style={{ padding: '12px 0', lineHeight: 1 }}><span>Pipe volume (gal/ft)</span></li>
                            </ul>
                            <ul>
                              <li><span>2</span></li>
                              <li><span>0.16</span></li>
                            </ul>
                            <ul>
                              <li><span>3</span></li>
                              <li><span>0.37</span></li>
                            </ul>
                            <ul>
                              <li><span>4</span></li>
                              <li><span>0.65</span></li>
                            </ul>
                            <ul>
                              <li><span>6</span></li>
                              <li><span>1.02</span></li>
                            </ul>
                            <ul>
                              <li><span>12</span></li>
                              <li><span>4.88</span></li>
                            </ul>
                          </div>
                        }
                      </Grid>
                      <Grid xs={6} className='stage_clip cip_vessels' style={{ marginLeft: 10 }}>
                        <span className='no_stage' title={translateObject('Vol in CIP tank')}> {translateObject('Vol in CIP tank')}</span>
                        <div className='vessels'>
                          <input
                            type='number'
                            id='piping_0'
                            disabled={ind === 0 ? false : isVolumeDisabled}
                            value={ele.voltank}
                            onFocus={e => e.target.select()}
                            className='cancel-handle Defautl_Large_input'
                            onInput={(e) => { changeCIPtank(e, ind); }}
                            placeholder={translateObject('0')}
                          />
                          <span className='cip_system_design S_Bold'>{units['Liquid Volume'] || unit_set_dict['Liquid Volume']}</span>
                        </div>
                      </Grid>
                    </div>
                  </div>
                );
              })}
            </Grid>
            <Grid xs={4} md={4} className='stage_right_child' style={{ borderRadius: 8, display: 'flex', border: '1px solid #C8C8DA', minHeight: 200, height: 'max-content' }}>
              <Grid container className='stage_right_child-con'>
                <Grid xs={6} md={6} className='stage_right_foulant' style={{ padding: '0 0 0 15px' }}>
                  <FormGroup className='mt10'>
                    <FormControlLabel className='no_stage' control={<Checkbox id='main_cln' checked={main_checked} onChange={(event) => selectRegistrationValue(event, 'maintenance')} />} label={translateObject('Maintenance Clean')} />
                  </FormGroup>
                  <Grid xs={12} className='stage_clip cip_vessels mt10'>
                    <span id='Foulant_type' className='cip_system_design no_stage'>{translateObject('Foulant Type')}</span>
                    <div className='vessels'>
                      <FormControl className='cip_form_control' sx={{ m: 1, minWidth: 120 }}>
                        <Select id='rgopt' value={foulantselect} onChange={(event) => selectRegistrationValue(event, 'foulant')}>
                          <MenuItem value=''>{translateObject('Select')}</MenuItem>
                          {foulantOption.map((ele) => (
                            <MenuItem id={ele.value} key={ele.value} value={ele.value}>{ele.value}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                  <FormGroup style={{ margin: '15px 0 0 0' }} className='mt10'>
                    <span id='Registration' className='cip_system_design no_stage'>{translateObject('Registration')}</span>
                    <FormControlLabel className='no_stage' control={<Checkbox id='nsf_app' checked={nsf_checked} onChange={(event) => selectRegistrationValue(event, 'nsf')} />} label={translateObject('NSF Approved')} />
                  </FormGroup>
                </Grid>
                <Grid xs={6} md={6} className='stage_right_material'>
                  <Grid xs={12} className='stage_clip cip_vessels mt10'>
                    <span className='cip_system_design no_stage'>{translateObject('Cleaner Type')}</span>
                    <div className='vessels'>
                      <FormControl className='cip_form_control cleaner_type' sx={{ m: 1, minWidth: 120 }}>
                        <Select id='clnType' disabled={nsf_checked || membrane_value !== 'polyamide'} value={cleanerSelect} onChange={handleCleanerChange}                  >
                          <MenuItem id='Liquid' value='0'>{translateObject('Liquid')}</MenuItem>
                          <MenuItem id='Powder' value='1'>{translateObject('Powder')}</MenuItem>
                          <MenuItem id='Single_Product' value='2'>{translateObject('Single Product')}</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid xs={12} className='stage_clip cip_vessels mt10'>
                    <span className='cip_system_design no_stage'>{translateObject('Cleaner Strength')}</span>
                    <div className='vessels'>
                      <FormControl className='cip_form_control' sx={{ m: 1, minWidth: 120 }}>
                        <Select id='clnStr' value={strengthSelect} onChange={handleStrengthChange}>
                          <MenuItem id='Standard' value='0'>{translateObject('Standard')}</MenuItem>
                          <MenuItem id='Mild' value='1'>{translateObject('Mild')}</MenuItem>
                          <MenuItem id='Strong' value='2'>{translateObject('Strong')}</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid xs={12} className='stage_clip cip_vessels mt10'>
                    <span className='cip_system_design no_stage'>{translateObject('Membrane Material')}</span>
                    <div className='vessels'>
                      <FormControl>
                        <RadioGroup
                          value={membrane_value}
                          name="radio-buttons-group"
                          onChange={membraneMaterial}
                        >
                          <FormControlLabel id='polyamide' className='no_stage' value="polyamide" control={<Radio />} label="Polyamide" />
                          <FormControlLabel id='cellulose_acetate' className='no_stage' value="cellulose acetate" control={<Radio />} label="Cellulose Acetate" />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
                {!(membrane_value === 'polyamide') && <Grid xs={12} md={12} className='stage_bottom_cleaning' style={{ margin: '10px !important' }}>
                  <div className='note'>
                    <span className='S_Regular'>
                      Note: The products listed on the next screen might not be avaliable in your region. In this case, please contact MemChem Product Applications team to define the best strategy.
                    </span>
                  </div>
                </Grid>}
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12} md={12} className='stage_bottom_cleaning' >
            <Grid xs={12} className='stage_clip cip_vessels mt10'>
              <span className='cip_system_design no_stage' style={{ width: 'auto' }}>{translateObject('Cleaning Strategies based on Foulant type')}</span>
              <div className='vessels'>
                <FormControl className='cip_feorm_control' sx={{ m: 1, minWidth: 120 }}>
                  <Select id='factSht' value={strategiesSelect} onChange={handleStrategiesChange}>
                    {cleaningFoulantOption.map((ele, ind) => <MenuItem key={ind} id={ele.key} value={ele.key} onClick={() => handleCIPdd(ele.key)} >{ele.val}</MenuItem>)}
                  </Select>
                </FormControl>
              </div>
            </Grid>
          </Grid>
          <Grid xs={12} md={12} className='stage_bottom_cleaning' style={{ marginTop: 20 }}>
            <div className='note'>
              <span className='S_Regular'>
                1. {translateObject('Text 1 CIP')}<br />
                2. {translateObject('Text 2 CIP')}<br />
                3. {translateObject('Text 3 CIP')}<br />
                4. {translateObject('Text 4 CIP')}
              </span>
            </div>
          </Grid>
        </Grid>
      </Grid>
      {
        visibleUnits && (
          <ExecuteContext.Provider value={executeEDIInfoData}>
            <SystemUnits
              visibleUnits={visibleUnits}
              handleCloseUnits={handleCloseOption}
              visibleDefaultUnits
              translateObject={translateObject}
            />
          </ExecuteContext.Provider>
        )
      }
      {
        showReportPopup && (
          <div className="file-share-draggable">
            <ReportCipPopup
              visibleQuickView={showReportPopup}
              closeQuickViewPopup={closeQuickViewPopup}
              cipReportData={cipReportData}
              reportDataObj={reportDataObj}
              isVolumeDisabled={isVolumeDisabled}
              setCipNotification={setCipNotification}
              translateObject={translateObject}
              cipSelect={cipSelect}
              dbTransactionDetails={dbTransactionDetails}
              units={units}
              setFetchLoading={setFetchLoading}
            />
          </div>
        )
      }
      {
        cipNotification &&
        <>
          <div className='over-lay' />
          <div className='cip-wrapper'>
            <div className="cipheader">
              <span style={{ fontWeight: 600 }}>Info Note</span>
              <span>
                <Tooltip title="Close" className="no-drag">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={() => { setCipNotification(false); }}
                    style={{ width: '14px', padding: '5px' }}
                    className="pointer no_drag"
                  />
                </Tooltip>
              </span>
            </div>
            <div className="cipcontent">
              <span>
                CIP systems that are designed to clean stages in series vary greatly in design.  It is important to optimize flow rates without too much flow traveling through the last stage of the system.  Veolia recommends not exceeding a 60 psi pressure drop in any stage. High pressure, in series cleaning (up to 175 psi) employs a booster pump from the CIP tank and the high pressure skid pump to deliver the appropriate flow. The pressure is controlled by a throttling valve on the main pump discharge, and either a concentrate valve or a bypass valve (in the case of orifice plate back pressure control). This method cleans all banks of the skid simultaneously. There will be a lower capital cost for this equipment, and less cleaning chemical and time will be required to clean the system.  Because the banks are cleaned in series, it is not possible to target an optimized flow rate per pressure vessel, as the flow rates will be different for each stage.  Please consult the O&&M manual for the system CIP to determine the recommended flow rate for the system, based on the banking arrangement and CIP skid.
              </span>
            </div>
          </div>
        </>
      }
    </Grid >
  );
}

export default CIP_Calculator_Form;